import { FILTER_OPTIONS } from 'modules/product/views/components/product-offers-header/data/filter-options.data';
import hasActiveFilter from 'helpers/has-active-filter';
import OfferInterface from 'interfaces/offer.interface';
import { OptionDataInterface } from 'modules/product/views/components/product-offers-header/interfaces/option.data.interface';

export default function getAvailableFilters(offers: OfferInterface[]): OptionDataInterface[] {
    const options = [...FILTER_OPTIONS];

    options.map(item => item.isDisabled = !offers.find(offer => hasActiveFilter([item.value], offer)));

    return options;
}
